import { GraphQLClient as GQLClient } from "graphql-request";

class AuthenticatedPurchaseGraphQLClient {
  private client: GQLClient;

  constructor(endpoint: string) {
    this.client = new GQLClient(endpoint);
  }

  async request<T = any>(
    query: string,
    variables?: Record<string, any>,
    token?: string | null,
  ): Promise<T> {
    try {
      if (!token) {
        throw new Error(
          "No authentication token provided for purchase API. Please authenticate first.",
        );
      }

      // Set the authorization header
      this.client.setHeader("Authorization", `Bearer ${token}`);

      console.log(
        "Purchase GraphQL: Making request to",
        import.meta.env.VITE_PURCHASE_URL,
        "with mutation/query:",
        query.split("\n")[0],
      );

      // Make the GraphQL request
      const data = await this.client.request<T>(query, variables);
      return data;
    } catch (error) {
      console.error("Purchase GraphQL Error:", error);
      if (error instanceof Error) {
        throw error;
      }
      throw new Error("Unknown error occurred during purchase GraphQL request");
    }
  }
}

// Create a singleton instance for purchase APIs
const purchaseGraphqlClient = new AuthenticatedPurchaseGraphQLClient(
  `${import.meta.env.VITE_PURCHASE_URL}/auth`,
);

export default purchaseGraphqlClient;

